import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  Grid,
  Paper,
  TextField,
  InputLabel,
  FormControl,
  Button,
  useMediaQuery,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { Employee } from '../TitleList';
import TitleBar from "../TitleBar";
import "./FixedEmployeeTable.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { selectEmployees } from "../Selectors/Master/ItemSelectors";
import { fetchEmployeeData } from "../../Store/PHPSlice/Employee";

const FixedEmployee = () => {
  const userdata = JSON.parse(localStorage.getItem('user'));
  const isDesktop = useMediaQuery("(min-width:768px)");
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [formData, setFormData] = useState({
    date: "",
    ledger: "",
    paymentType: "",
    paymentAmount: "",
    workHours: 8,
    workingDays: 6,
    perHour: "",
    perDay: "",
    punchId: "",
    work_type: '',
    locId: '',
    locNm: '',
    userId: userdata?.ID
  });
  const [loading, setLoading] = useState(false);
  const [emplist, setEmplist] = useState([]);
  const [fixEmpReg, setFixEmpReg] = useState([]);
  useEffect(() => {
    fetchFixedEmplist();
    fetchFixedEmpReg();
  }, []);



  const fetchFixedEmplist = async () => {
    try {
      const res = await axios.get(`${baseUrl}?apicall=getFixedEmployeeList`);
      const data = res?.data?.data;
      // console.log(data);
      setEmplist(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchFixedEmpReg = async () => {
    try {
      const res = await axios.get(`${baseUrl}?apicall=getFixedEmployeeReg`);

      const data = res?.data?.data;
      setFixEmpReg(data);
    } catch (error) {
      console.error(error);
    }
  };
  // console.log(fixEmpReg);

  const [tableData, setTableData] = useState([
    {
      id: 1,
      date: "2025-04-01",
      ledger: "RUPA NANDAL",
      paymentType: "Weekly",
      paymentAmount: 4125,
      workHours: 8,
      workingDays: 6,
      perHour: "85.94",
      perDay: "687.52",
    },
    {
      id: 2,
      date: "2025-04-02",
      ledger: "EMPLOYEE 2",
      paymentType: "Monthly",
      paymentAmount: 18000,
      workHours: 8,
      workingDays: 26,
      perHour: "21.63",
      perDay: "173.04",
    },
    {
      id: 3,
      date: "2025-04-03",
      ledger: "EMPLOYEE 3",
      paymentType: "Days",
      paymentAmount: 800,
      workHours: 8,
      workingDays: 1,
      perHour: "100.00",
      perDay: "800.00",
    },
  ]);

  const [filters, setFilters] = useState({});


  const handleSelectChange = (name, selectedOption) => {
    handleChange({
      target: {
        name,
        value: selectedOption ? selectedOption.value : ""
      }
    });
  };


  // 🔁 Handle Form Change
  const handleChange = (e) => {
    const { name, value } = e.target;

    let updated = { ...formData, [name]: value };
    // When employee (ledger) changes
    if (name === "ledger") {
      const emp = emplist?.find(item => item.ID === value);
      console.log(emp);
      if (emp) {
        updated.paymentType = emp.payType;   // Weekly / Monthly
        updated.punchId = emp.punchId;
        updated.locId = emp.locId;
        updated.locNm = emp.locNm;

        if (emp.payType === "Weekly") {
          updated.paymentAmount = emp.payAmt / 4;
          updated.workingDays = 6;
        } else {
          updated.paymentAmount = emp.payAmt;
          updated.workingDays = 26;
        }
      }
    }
    // When payment type is changed manually
    if (name === "paymentType") {
      const emp = emplist?.find(item => item.ID === updated.ledger);
      const baseAmt = emp?.payAmt || 0;

      if (value === "Weekly") {
        updated.paymentAmount = baseAmt / 4;
        updated.workingDays = 6;
      } else {
        updated.paymentAmount = baseAmt;
        updated.workingDays = 26;
      }
    }


    const { paymentType, paymentAmount, workHours, workingDays } = updated;

    if (paymentType && paymentAmount && workHours) {
      let perHour = "";
      let perDay = "";

      // if (paymentType === "Weekly") {
      //   perHour = paymentAmount / (workHours * workingDays);
      // }

      // if (paymentType === "Monthly") {
      //   perHour = paymentAmount / (workHours * workingDays * 4);
      // }

      // if (paymentType === "Days") {
      //   perHour = paymentAmount / workHours;
      // }

      // if (perHour) {
      //   perDay = perHour * workHours;
      // }

      perDay = paymentAmount / workingDays;
      perHour = perDay / workHours;

      updated.perHour = perHour ? perHour.toFixed(2) : "";
      updated.perDay = perDay ? perDay.toFixed(2) : "";
    }

    setFormData(updated);
  };

  // ✅ 1. FIRST: static data
  const payType = [
    { ID: "Weekly", empNm: "Weekly" },
    { ID: "Monthly", empNm: "Monthly" }
  ];

  const worktypes = [
    { ID: "Hr", empNm: "Hr" },
    { ID: "Day", empNm: "Day" }
  ];

  // ✅ 2. THEN: react-select options
  const ledgerOptions = emplist?.map(emp => ({
    value: emp.ID,
    label: emp.empNm,
  })) || [];

  const payTypeOptions = payType.map(p => ({
    value: p.ID,
    label: p.empNm,
  }));

  const workTypeOptions = worktypes.map(w => ({
    value: w.ID,
    label: w.empNm,
  }));




  // ➕ Submit Data to Table
  const handleSubmit = async (e) => {
    e.preventDefault();
    // setTableData([...tableData, { id: tableData.length + 1, ...formData }]);
    // console.log(formData);
    setLoading(true);
    try {
      const res = await axios.post(`${baseUrl}?apicall=insertFixedEmployees`, formData);
      // console.log(res?.data);
      const data = res.data;
      if (data?.status === "success") {
        alert(data.msg);
        window.location.reload();
      } else {
        if (Array.isArray(data?.msg)) {
          alert(data.msg.join("\n"));
        } else if (typeof data?.msg === "string") {
          alert(data.msg);
        }
      }
    } catch (error) {
      console.error(error);
      // alert(error);
    } finally {
      setLoading(false);
    }
  };

  // 🔍 Filter Logic
  const filteredData = fixEmpReg?.filter((row) =>
    Object.keys(filters).every((key) =>
      row[key]
        ?.toString()
        .toLowerCase()
        .includes(filters[key]?.toLowerCase() || "")
    )
  );


  return (
    <>
      <TitleBar data={Employee} />

      <div style={{ margin: "1% 0.5%" }}>
        {/* ================= FORM ================= */}
        <Paper style={{ padding: "1vh", marginBottom: "12px" }}>
          <Grid container spacing={1}>
            {[
              { label: "Date", name: "date", type: "date" },
              { label: "Punching ID", name: "punchId" },
              {
                label: "Ledger",
                name: "ledger",
                select: true,
                options: emplist,
              },
              { label: 'Location', name: 'locNm', disabled: true },
              {
                label: "Payment Type",
                name: "paymentType",
                select: true,
                options: payType,
              },
              {
                label: "work Type",
                name: "work_type",
                select: true,
                options: worktypes,
              },
              { label: "Payment Amount", name: "paymentAmount" },
              { label: "Working Days", name: "workingDays" },
              { label: "Work Hours", name: "workHours" },
              { label: 'Per Day Payment', name: 'perDay', disabled: true },
              { label: "Per Hour Payment", name: "perHour", disabled: true },
            ].map((field, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid
                    item
                    style={isDesktop ? { width: "35%" } : { width: "100%" }}
                  >
                    <InputLabel>{field.label} :</InputLabel>
                  </Grid>
                  <Grid item xs>
                    <FormControl fullWidth>
                      {field.select ? (
                        <Select
                          options={
                            field.name === "ledger"
                              ? ledgerOptions
                              : field.name === "paymentType"
                                ? payTypeOptions
                                : workTypeOptions
                          }
                          value={
                            field.name === "ledger"
                              ? ledgerOptions.find(o => o.value === formData.ledger)
                              : field.name === "paymentType"
                                ? payTypeOptions.find(o => o.value === formData.paymentType)
                                : workTypeOptions.find(o => o.value === formData.work_type)
                          }
                          onChange={(option) =>
                            handleSelectChange(field.name, option)
                          }
                          isClearable
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: "40px",
                            }),
                          }}
                        />
                      ) : (
                        <TextField
                          type={field.type || "text"}
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleChange}
                          disabled={field.disabled}
                          size="small"
                          fullWidth
                        />
                      )}

                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            ))}

            <Grid item xs={12} textAlign="center" mt={1}>
              <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                {
                  loading === true ?
                    <><CircularProgress size="20px" /> wait...</> :
                    "Submit"
                }
              </Button>
            </Grid>
          </Grid>
        </Paper>

        {/* ================= TABLE ================= */}
        <Paper style={{ padding: "8px" }}>
          <Grid container className="table-row header">
            {[
              "ID",
              "Date",
              "Punching ID",
              "Ledger",
              "Payment Type",
              "Work Type",
              "Amount",
              "Days",
              "Per Day",
              "Hours",
              "Per Hour"
            ].map((h, i) => (

              <Grid item
                xs={
                  h === 'ID'
                    ? 0.5
                    : h === 'Ledger'
                      ? 1.8
                      : 1
                }
                key={i}>
                {h}
              </Grid>
            ))}
          </Grid>

          {/* 🔍 Filters */}
          <Grid container className="table-row filter">
            {[
              "id",
              "date",
              "punchId",
              "ledger",
              "paymentType",
              "work_type",
              "paymentAmount",
              "workingDays",
              "perDay",
              "workHours",
              "perHour"
            ].map((key, i) => (
              <Grid item
                xs={
                  key === 'id'
                    ? 0.5
                    : key === 'ledger'
                      ? 1.8
                      : 1
                }
                key={i}>
                <input
                  className="table-filter"
                  onChange={(e) =>
                    setFilters({ ...filters, [key]: e.target.value })
                  }
                />
              </Grid>
            ))}
          </Grid>

          {/* 📄 Data */}
          {filteredData?.map((row, index) => (
            <Grid container className="table-row data" key={row.id}>
              <Grid item xs={0.5}>
                {index + 1}
              </Grid>
              <Grid item xs={1}>
                {row.date}
              </Grid>
              <Grid item xs={1}>
                {row.punchId}
              </Grid>
              <Grid item xs={1.8}>
                {row.ledger}
              </Grid>
              <Grid item xs={1}>
                {row.paymentType}
              </Grid>
              <Grid item xs={1}>
                {row.work_type}
              </Grid>
              <Grid item xs={1}>
                {row.paymentAmount}
              </Grid>
              <Grid item xs={1}>
                {row.workingDays}
              </Grid>
              <Grid item xs={1}>
                {row.perDay}
              </Grid>
              <Grid item xs={1}>
                {row.workHours}
              </Grid>
              <Grid item xs={1}>
                {row.perHour}
              </Grid>
            </Grid>
          ))}
        </Paper>
      </div>
    </>
  );
};

export default FixedEmployee;
